import React, { useMemo, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

import BadgeFileInput from "./BadgeFileInput";

const ChallengeForm = ({ initialValues, mode, onSubmit }) => {
  const isView = mode === "view";
  const isCreate = mode === "create";
  const isEdit = mode === "edit";

  const defaults = useMemo(() => {
    const safe = initialValues || {};
    return {
      name: safe.name || "",
      description: safe.description || "",
      imageUrl: safe.imageUrl || "",
      badgeExplorerImageUrl: safe.badgeExplorerImageUrl || "",
      badgeAdventurerImageUrl: safe.badgeAdventurerImageUrl || "",
      badgeConquerorImageUrl: safe.badgeConquerorImageUrl || "",
      badgeLegendImageUrl: safe.badgeLegendImageUrl || "",
      totalDistanceKm:
        safe.totalDistanceKm != null && safe.totalDistanceKm !== ""
          ? String(safe.totalDistanceKm)
          : "",
      startDate: safe.startDate ? String(safe.startDate).slice(0, 10) : "",
      endDate: safe.endDate ? String(safe.endDate).slice(0, 10) : "",
      isActive: Boolean(safe.isActive),
    };
  }, [initialValues]);

  const [localStops, setLocalStops] = useState(
    Array.isArray(initialValues && initialValues.stops)
      ? initialValues.stops
      : []
  );

  const addStop = () => {
    setLocalStops([
      ...localStops,
      { distanceKm: "", title: "", fact: "", order: localStops.length + 1 },
    ]);
  };

  const removeStop = (index) => {
    const next = localStops
      .filter((_, i) => i !== index)
      .map((s, i) => ({
        ...s,
        order: i + 1,
      }));
    setLocalStops(next);
  };

  const updateStop = (index, field, value) => {
    const next = [...localStops];
    next[index] = { ...next[index], [field]: value };
    setLocalStops(next);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeof onSubmit === "function") {
      onSubmit(e, localStops);
    }
  };

  return (
    <Card style={{ marginBottom: 0 }}>
      <CardBody>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="name">Nombre del reto *</Label>
                <Input
                  type="text"
                  name="name"
                  id="name"
                  defaultValue={defaults.name}
                  required
                  disabled={isView}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="totalDistanceKm">Distancia total (km) *</Label>
                <Input
                  type="number"
                  name="totalDistanceKm"
                  id="totalDistanceKm"
                  step="0.1"
                  min="0"
                  defaultValue={defaults.totalDistanceKm}
                  required
                  disabled={isView}
                />
              </FormGroup>
            </Col>
          </Row>

          <FormGroup>
            <Label for="description">Descripción</Label>
            <Input
              type="textarea"
              name="description"
              id="description"
              rows="3"
              defaultValue={defaults.description}
              disabled={isView}
            />
          </FormGroup>

          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="startDate">Fecha de inicio *</Label>
                <Input
                  type="date"
                  name="startDate"
                  id="startDate"
                  defaultValue={defaults.startDate}
                  required
                  disabled={isView}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="endDate">Fecha de fin *</Label>
                <Input
                  type="date"
                  name="endDate"
                  id="endDate"
                  defaultValue={defaults.endDate}
                  required
                  disabled={isView}
                />
              </FormGroup>
            </Col>
          </Row>

          <FormGroup>
            {(isCreate || isEdit) && (
              <BadgeFileInput
                id="imageFile"
                name="imageFile"
                label="Imagen del reto (banner) *"
                disabled={isView}
              />
            )}
            {isView && (
              <div style={{ marginBottom: "1rem" }}>
                <div style={{ fontWeight: 600, marginBottom: "0.5rem", color: "#1D1F3F" }}>
                  Imagen del reto (banner)
                </div>
                {defaults.imageUrl ? (
                  <div
                    style={{
                      border: "1px solid rgba(29, 31, 63, 0.35)",
                      borderRadius: "10px",
                      background: "#fff",
                      height: "140px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={defaults.imageUrl}
                      alt="Banner del reto"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                ) : (
                  <div style={{ color: "#666" }}>Sin imagen</div>
                )}
              </div>
            )}
          </FormGroup>

          <Row>
            <Col md={6}>
              {(isCreate || isEdit) && (
                <FormGroup>
                  <BadgeFileInput
                    id="badgeExplorerImageFile"
                    name="badgeExplorerImageFile"
                    label="Insignia Explorador (0-49%)"
                    disabled={isView}
                  />
                </FormGroup>
              )}
              {isView && (
                <div style={{ marginBottom: "1rem" }}>
                  <div style={{ fontWeight: 600, marginBottom: "0.5rem", color: "#1D1F3F" }}>
                    Insignia Explorador (0-49%)
                  </div>
                  {defaults.badgeExplorerImageUrl ? (
                    <div
                      style={{
                        border: "1px solid rgba(29, 31, 63, 0.35)",
                        borderRadius: "10px",
                        background: "#fff",
                        height: "140px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={defaults.badgeExplorerImageUrl}
                        alt="Insignia Explorador"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{ color: "#666" }}>Sin imagen</div>
                  )}
                </div>
              )}
            </Col>
            <Col md={6}>
              {(isCreate || isEdit) && (
                <FormGroup>
                  <BadgeFileInput
                    id="badgeAdventurerImageFile"
                    name="badgeAdventurerImageFile"
                    label="Insignia Aventurero (50-99%)"
                    disabled={isView}
                  />
                </FormGroup>
              )}
              {isView && (
                <div style={{ marginBottom: "1rem" }}>
                  <div style={{ fontWeight: 600, marginBottom: "0.5rem", color: "#1D1F3F" }}>
                    Insignia Aventurero (50-99%)
                  </div>
                  {defaults.badgeAdventurerImageUrl ? (
                    <div
                      style={{
                        border: "1px solid rgba(29, 31, 63, 0.35)",
                        borderRadius: "10px",
                        background: "#fff",
                        height: "140px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={defaults.badgeAdventurerImageUrl}
                        alt="Insignia Aventurero"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{ color: "#666" }}>Sin imagen</div>
                  )}
                </div>
              )}
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              {(isCreate || isEdit) && (
                <FormGroup>
                  <BadgeFileInput
                    id="badgeConquerorImageFile"
                    name="badgeConquerorImageFile"
                    label="Insignia Conquistador (100-149%)"
                    disabled={isView}
                  />
                </FormGroup>
              )}
              {isView && (
                <div style={{ marginBottom: "1rem" }}>
                  <div style={{ fontWeight: 600, marginBottom: "0.5rem", color: "#1D1F3F" }}>
                    Insignia Conquistador (100-149%)
                  </div>
                  {defaults.badgeConquerorImageUrl ? (
                    <div
                      style={{
                        border: "1px solid rgba(29, 31, 63, 0.35)",
                        borderRadius: "10px",
                        background: "#fff",
                        height: "140px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={defaults.badgeConquerorImageUrl}
                        alt="Insignia Conquistador"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{ color: "#666" }}>Sin imagen</div>
                  )}
                </div>
              )}
            </Col>
            <Col md={6}>
              {(isCreate || isEdit) && (
                <FormGroup>
                  <BadgeFileInput
                    id="badgeLegendImageFile"
                    name="badgeLegendImageFile"
                    label="Insignia Leyenda (150%+)"
                    disabled={isView}
                  />
                </FormGroup>
              )}
              {isView && (
                <div style={{ marginBottom: "1rem" }}>
                  <div style={{ fontWeight: 600, marginBottom: "0.5rem", color: "#1D1F3F" }}>
                    Insignia Leyenda (150%+)
                  </div>
                  {defaults.badgeLegendImageUrl ? (
                    <div
                      style={{
                        border: "1px solid rgba(29, 31, 63, 0.35)",
                        borderRadius: "10px",
                        background: "#fff",
                        height: "140px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={defaults.badgeLegendImageUrl}
                        alt="Insignia Leyenda"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{ color: "#666" }}>Sin imagen</div>
                  )}
                </div>
              )}
            </Col>
          </Row>

          <FormGroup check style={{ marginBottom: "1rem" }}>
            <Input
              type="checkbox"
              name="isActive"
              id="isActive"
              defaultChecked={defaults.isActive}
              disabled={isView}
            />
            <Label check for="isActive">
              Reto activo
            </Label>
          </FormGroup>

          <div className="stops-section">
            <div
              className="stops-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h4 style={{ margin: 0 }}>Paradas del reto</h4>
              {!isView && (
                <Button
                  type="button"
                  color="secondary"
                  size="sm"
                  onClick={addStop}
                >
                  Añadir parada
                </Button>
              )}
            </div>

            {localStops.length === 0 && (
              <div style={{ marginTop: "0.75rem", color: "#666" }}>
                No hay paradas registradas.
              </div>
            )}

            {localStops.map((stop, index) => (
              <Card
                key={index}
                className="mb-3"
                style={{ marginTop: "0.75rem" }}
              >
                <CardBody>
                  <Row>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Distancia (km)</Label>
                        <Input
                          type="number"
                          step="0.1"
                          min="0"
                          placeholder="Ej. 50"
                          value={stop.distanceKm}
                          disabled={isView}
                          onChange={(e) =>
                            updateStop(index, "distanceKm", e.target.value)
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Título de la parada</Label>
                        <Input
                          type="text"
                          value={stop.title || ""}
                          disabled={isView}
                          placeholder="Ej. Pirámides de Teotihuacán"
                          onChange={(e) =>
                            updateStop(index, "title", e.target.value)
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Dato curioso</Label>
                        <Input
                          type="text"
                          value={stop.fact || ""}
                          disabled={isView}
                          placeholder="Ej. Construidas en el siglo II a.C."
                          onChange={(e) =>
                            updateStop(index, "fact", e.target.value)
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={1}>
                      {!isView && (
                        <FormGroup>
                          <Label>&nbsp;</Label>
                          <Button
                            type="button"
                            color="danger"
                            size="sm"
                            onClick={() => removeStop(index)}
                            disabled={localStops.length === 1}
                            block
                          >
                            ×
                          </Button>
                        </FormGroup>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))}
          </div>

          {!isView && (
            <Row className="mt-4">
              <Col>
                <Button type="submit" color="primary" className="float-right">
                  {isCreate ? "Crear reto" : "Guardar cambios"}
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </CardBody>
    </Card>
  );
};

export default ChallengeForm;
